<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'acl_submodulo_id'"
            :listaDeOptions="listaDeSubModulos"
            v-model="formulario.acl_submodulo_id"
            :optionLabel="'submodulo'"
            :placeholder="'Submódulo'"
            :error="validationErrors.first('acl_submodulo_id')"
            data-vv-as="Submódulo"
            v-validate="'required'"
          />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'descricao'"
            v-model="formulario.descricao" 
            :placeholder="'Descrição'"
            data-vv-as="descricao"
            :error="validationErrors.first('descricao')"
         />
      </div>      
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'rota'"
            v-model="formulario.rota" 
            :placeholder="'Rota'"
            data-vv-as="rota"
            v-validate="'required'"
            :error="validationErrors.first('rota')"
         />
      </div>
      <div class="mb-3">
        <SGPFormToggleComponent
              name="link_externo"
              titulo="Link Externo"
              v-model="formulario.link_externo"      
            />
      </div> 
    
      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioVueComponenteMenuComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    vueComponenteMenu: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.vueComponenteMenu || {
        rota: '',
        link_externo: 0,
        descricao: '',
        acl_submodulo_id: ''
      }
    }
  },
   created () {
    this.listarSubModulos();
  },
  computed: {
    ...mapGetters('submodulos', ['listaDeSubModulos'])
  },
  methods: {
    ...mapActions('vueComponentesMenus', [
      'salvarVueComponenteMenu',
      'buscarVueComponenteMenu',
      'atualizarVueComponenteMenu'
    ]),
    ...mapActions('submodulos', [
      'listarSubModulos'
    ]),
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
        this.formulario.rota = '';
        this.formulario.link_externo = 0;
        this.formulario.descricao = '';
        this.formulario.acl_submodulo_id = '';
        this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarVueComponenteMenu(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarVueComponenteMenu(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }


}
</script>